import React from 'react';
import { Instagram, MessageCircle, Video } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-primary border-t border-dark-border py-12 mt-20" data-id="element-19">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center" data-id="element-20">
        <h2 className="text-3xl font-heading tracking-widest text-white mb-2" data-id="element-21">
          ALEKS SZULC
        </h2>
        <p className="text-accent-blue font-heading tracking-wider mb-8" data-id="element-22">
          BORN TO FIGHT. BUILT TO WIN.
        </p>

        <div className="flex gap-6 mb-8" data-id="element-23">
          <a href="https://www.instagram.com/aleks.szulc1/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-elevated border border-dark-border flex items-center justify-center text-gray-400 hover:text-white hover:border-accent-blue transition-all" data-id="element-24">
            <Instagram className="w-5 h-5" data-id="element-25" />
          </a>
          <a href="https://www.tiktok.com/@aleks.szulc1" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-elevated border border-dark-border flex items-center justify-center text-gray-400 hover:text-white hover:border-accent-blue transition-all" data-id="element-26">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-27">
              <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" data-id="element-28" />
            </svg>
          </a>
          <a href="https://wa.me/48536052998" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-elevated border border-dark-border flex items-center justify-center text-gray-400 hover:text-white hover:border-accent-blue transition-all" data-id="element-29">
            <MessageCircle className="w-5 h-5" data-id="element-30" />
          </a>
        </div>

        <p className="text-gray-600 text-sm font-body" data-id="element-31">
          © {new Date().getFullYear()} Aleks Szulc. All Rights Reserved.
        </p>
      </div>
    </footer>;
}